import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import PersonRemoveRoundedIcon from '@mui/icons-material/PersonRemoveRounded';
import { Box, Button, Divider, Tooltip } from '@mui/material';
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import ManagementGridProps from '../lib/ManagementGridProps';

/**
 * The properties for the members grid toolbar
 */
interface MembersGridToolbarProps {
  /**
   * The action to take when the invite button is clicked
   */
  onInviteClick: () => void;
  /**
   * The action to take when the remove members button is clicked
   */
  onRemoveClick: () => void;
  /**
   * Enable or disable the remove button
   */
  disableRemoveButton: boolean;
  /**
   * Properties related to the management grid
   */
  managementGridProps: ManagementGridProps;
}

/**
 * A custom toolbar for the members grid
 */
const MembersGridToolbar = (props: MembersGridToolbarProps) => {
  return (
    <>
      <Box display="flex" justifyContent="space-between" marginBottom=".5em">
        <GridToolbarContainer sx={{ paddingTop: '1em', paddingLeft: '1em' }}>
          {!props.managementGridProps.orgId && (
            <>
              <Button
                color="success"
                variant="contained"
                size="small"
                onClick={props.onInviteClick}
                startIcon={<AddCircleRoundedIcon />}
              >
                Invite Members
              </Button>
              <Tooltip
                title={
                  props.disableRemoveButton
                    ? 'You can only remove expected members.'
                    : ''
                }
                arrow
              >
                <span
                  style={{
                    cursor: props.disableRemoveButton ? 'help' : 'default',
                  }}
                >
                  {/* Wrapping with a span because disabled buttons do not trigger tooltips */}
                  <Button
                    color="error"
                    variant="contained"
                    size="small"
                    startIcon={<PersonRemoveRoundedIcon />}
                    disabled={props.disableRemoveButton}
                    onClick={props.onRemoveClick}
                  >
                    Remove Members
                  </Button>
                </span>
              </Tooltip>
            </>
          )}
          <GridToolbarColumnsButton variant="contained" />
          <GridToolbarDensitySelector variant="contained" />
          <GridToolbarExport variant="contained" />
        </GridToolbarContainer>
        <GridToolbarQuickFilter
          variant="outlined"
          size="small"
          sx={{ marginTop: '1em', marginRight: '1em' }}
        />
      </Box>
      <Divider />
    </>
  );
};

export default MembersGridToolbar;
